import React, { useEffect, useState } from "react";
import NavLateral from "./navLateral";
import { useNavigate, useParams } from "react-router-dom";
import ProcessoLoading from "../../load/processoLoading";
import api from "../../services/api";
import RegisterAccess from "../../utils/registerAccess";
import HeaderSession from "../../utils/headerSession";

export default function GestLicenciados({ element: component, ...rest }) {
  const navigate = useNavigate();
  const { id } = useParams();
  const [estabelecimento, setEstabelecimento] = useState(null);

  useEffect(() => {
    setEstabelecimento(null);

    api.get(`/estabelecimento/${id}`)
      .then(response => {
        const est = response.data.estabelecimento;
        if (est.approved === false || est.status !== 'Activo') {
          navigate(`/admin/analise/solicitacao-de-licenciamento/${id}`);
          return;
        }
        setEstabelecimento(est);
      })
      .catch(() => {});
  }, [id]);

  return (
    <div className="tw-max-w-7xl tw-mx-auto tw-px-4 tw-pb-10">
      <RegisterAccess page={'gestão de estabelecimento licenciado'} />
      <HeaderSession title={'GESTÃO DE ESTABELECIMENTO LICENCIADO'} />

      {estabelecimento ? (
        <div className="tw-flex tw-gap-5 tw-items-start">

          {/* ── Nav Lateral (sticky) ── */}
          <div
            className="tw-w-[290px] tw-flex-shrink-0"
            style={{ position: 'sticky', top: 70 }}
          >
            <NavLateral estabelecimento={estabelecimento} />
          </div>

          {/* ── Conteúdo principal ── */}
          <div className="tw-flex-1 tw-min-w-0">
            {React.cloneElement(component, { estabelecimento })}
          </div>

        </div>
      ) : (
        <ProcessoLoading />
      )}
    </div>
  );
}
